import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _classCallCheck from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _isNativeReflectConstruct from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/isNativeReflectConstruct";
import _getPrototypeOf from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import MultiFilter from './MultiFilter';
import SingleSelect from './SingleSelect';
import MultiToggle from './MultiToggle';
import SingleToggle from './SingleToggle';
import DateFilter from './DateFilter';
import { FacetWidgetType } from './DynamicListingComponent';
import { ReactComponent as IconArrowLeft } from '../../resources/icons/IconArrowLeft.svg';
import { tealiumMergeClickData, tealiumClickFunc } from '../../utils/tealium';
import { mobileCheck } from "../../utils";
var FilterBlock = /*#__PURE__*/function (_React$Component) {
  function FilterBlock() {
    var _this;
    _classCallCheck(this, FilterBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FilterBlock, [].concat(args));
    _defineProperty(_this, "state", {
      filterOpen: false,
      facetsWidgetsOpenStatus: {},
      filtersCount: 0,
      filtersValue: {}
    });
    _defineProperty(_this, "getFiltersCount", function () {
      var filters = _this.props.filters;
      if (filters || Object.keys(filters).length !== 0) {
        var count = 0;
        for (var key in filters) {
          var isEmty = filters[key].length === 1 && filters[key].includes('');
          if (filters[key].length !== 0 && !isEmty) {
            count = count + 1;
          }
        }
        _this.setState({
          filtersCount: count
        });
      }
    });
    // Close all filters popups and selectboxes.
    _defineProperty(_this, "initializeDropdownState", function (e) {
      e && e.preventDefault();
      var newFacetsStatus = {};
      // eslint-disable-next-line array-callback-return
      _this.props.facetsSchema.map(function (_ref) {
        var facetName = _ref.facetName;
        return facetName.value;
      }).map(function (facetName) {
        newFacetsStatus[facetName] = false;
      });
      _this.setState({
        facetsWidgetsOpenStatus: newFacetsStatus
      });
    });
    // Open/close particular filter's popup/selectbox.
    _defineProperty(_this, "setFilterDropdownState", function (state, key) {
      var results = _this.props.facetsSchema.map(function (_ref2) {
        var facetName = _ref2.facetName;
        return facetName.value;
      }).reduce(function (acc, itemKey) {
        acc[itemKey] = itemKey === key ? state : false;
        return acc;
      }, {});
      _this.setState({
        facetsWidgetsOpenStatus: results
      });
    });
    // Submit new filters, trigger research and close Filters block.
    _defineProperty(_this, "setFilterMultipleChoicesState", function (filters, filterName, isOpened) {
      _this.props.setFilters(_objectSpread(_objectSpread({}, _this.props.filters), {}, _defineProperty2({}, filterName, filters)));
      if (mobileCheck() && !isOpened) {
        _this.setState({
          filterOpen: false
        });
      }
    });
    // Submit new filters, trigger research and close Filters block.
    _defineProperty(_this, "setFilterChoiceState", function (checked, key, filterName, isSingleSelect) {
      var result = _objectSpread({}, _this.props.filters);
      result[filterName] = isSingleSelect ? [key] : FilterBlock.toggleItem(result[filterName], key, checked);
      _this.props.setFilters(result);
      if (mobileCheck()) {
        _this.setState({
          filterOpen: false
        });
      }
    });
    // Reset all checkboxes in single filter.
    _defineProperty(_this, "resetFilterChoiceState", function (filterName) {
      var result = _objectSpread({}, _this.props.filters);
      result[filterName] = [];
      _this.props.setFilters(result);
      _this.getFiltersCount();
    });
    // Reset all filters back to empty.
    _defineProperty(_this, "resetFilters", function (e) {
      _this.props.setFilters({});
      _this.getFiltersCount();
      e.preventDefault();
    });
    // Open/close Filters panel.
    _defineProperty(_this, "toggleFilter", function (e) {
      if (mobileCheck()) {
        _this.setState(function (prevState) {
          if (prevState.filterOpen) {
            document.body.classList.remove('filter__wrapper--open');
          } else {
            document.body.classList.add('filter__wrapper--open');
          }
          return {
            filterOpen: !prevState.filterOpen
          };
        });
      }
      e.preventDefault();
    });
    _defineProperty(_this, "submitAll", function (e) {
      _this.getFiltersCount();
      _this.toggleFilter(e);
    });
    return _this;
  }
  _inherits(FilterBlock, _React$Component);
  return _createClass(FilterBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeDropdownState();
      this.getFiltersCount();
      if (!mobileCheck()) {
        this.setState({
          filterOpen: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.filters !== this.props.filters) {
        this.getFiltersCount();
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      if (nextProps.facets !== this.props.facets || nextProps.facetsSchema !== this.props.facetsSchema || nextProps.resultsAmount !== this.props.resultsAmount) {
        !mobileCheck() && this.initializeDropdownState();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState !== this.state || nextProps.facets !== this.props.facets || nextProps.facetsSchema !== this.props.facetsSchema || nextProps.resultsAmount !== this.props.resultsAmount;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var isFilterSubmenuOpen = Object.values(this.state.facetsWidgetsOpenStatus).find(function (isOpen) {
        return isOpen;
      });
      var filtersPerRows = [];
      var row = 0;
      var _this$props = this.props,
        filtersClickAnalytics = _this$props.filtersClickAnalytics,
        fitlersCategoryAnalytics = _this$props.fitlersCategoryAnalytics,
        fitlersClearAnalytics = _this$props.fitlersClearAnalytics,
        fitlersValueAnalytics = _this$props.fitlersValueAnalytics,
        filtersShowResultsAnalytics = _this$props.filtersShowResultsAnalytics,
        params = _this$props.params;
      // eslint-disable-next-line array-callback-return
      this.props.facetsSchema.map(function (facet) {
        // This mapping is required to render all widget types 3 per row, except Toggle ones,
        // they need whole separate row.
        var isOnePerLine = facet.widgetType.value === FacetWidgetType.MULTI_TOGGLE || facet.widgetType.value === FacetWidgetType.SINGLE_TOGGLE;
        filtersPerRows[row] = filtersPerRows[row] || [];
        if (isOnePerLine) {
          if (filtersPerRows[row].length !== 0) {
            filtersPerRows[++row] = [];
          }
          filtersPerRows[row].push(facet);
          row++;
        } else {
          filtersPerRows[row].push(facet);
          if (filtersPerRows[row].length === 3) {
            row++;
          }
        }
      });
      var headerDirection = this.props.rtl ? {
        flexDirection: 'row-reverse'
      } : {};
      var filterScrollDirection = this.props.rtl ? {
        marginRight: '-30px'
      } : {
        marginLeft: '-30px'
      };
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "filter__wrapper ".concat(this.state.filterOpen ? 'filter__wrapper--open' : '', " ").concat(isFilterSubmenuOpen ? 'filter__wrapper--submenu-open' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "row ".concat(mobileCheck() ? '' : 'hide-menu-trigger-button')
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-md-4"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-md-4"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary js-filters-trigger filter__toggle",
        onClick: function onClick(e) {
          tealiumClickFunc(tealiumMergeClickData(filtersClickAnalytics, params));
          _this2.toggleFilter(e);
        }
      }, this.props.filtersButtonLabel, this.state.filtersCount > 0 && " (".concat(this.state.filtersCount, ")"))), /*#__PURE__*/React.createElement("div", {
        className: "col-md-4"
      })), /*#__PURE__*/React.createElement("div", {
        className: "filter"
      }, /*#__PURE__*/React.createElement("div", {
        className: "filter__header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: headerDirection
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-auto"
      }, /*#__PURE__*/React.createElement("a", {
        className: "body-medium filter__header-back-link js-btn-close-panel back-icon-color",
        href: "/#",
        onClick: this.initializeDropdownState,
        "aria-label": "Close field"
      }, /*#__PURE__*/React.createElement(IconArrowLeft, null)), /*#__PURE__*/React.createElement("a", {
        className: "body-medium filter__header-links js-filters-close back-icon-color",
        href: "/#",
        onClick: this.toggleFilter,
        "aria-label": "Close filter"
      }, /*#__PURE__*/React.createElement(IconArrowLeft, null))), /*#__PURE__*/React.createElement("div", {
        className: "col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "filter__header-text body-medium"
      }, /*#__PURE__*/React.createElement("span", null, this.props.filtersButtonLabel), /*#__PURE__*/React.createElement("span", {
        className: "js-opened-filter-label submenu__text"
      }, " "))), /*#__PURE__*/React.createElement("div", {
        className: "col-auto"
      }, /*#__PURE__*/React.createElement("a", {
        className: "body-medium filter__header-links",
        href: "/#",
        onClick: this.resetFilters,
        "aria-label": "Clear all",
        "aria-labelledby": "Clear all"
      }, this.props.clearAllButtonLabel)))), /*#__PURE__*/React.createElement("div", {
        className: "filter__scroll",
        style: filterScrollDirection
      }, filtersPerRows.map(function (row, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "filter__row",
          key: "filter-row-".concat(index)
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-md col-lg-9 offset-lg-1"
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, row.map(function (facetDefinition) {
          var Component;
          switch (facetDefinition.widgetType.value) {
            case FacetWidgetType.MULTI_TOGGLE:
              Component = MultiToggle;
              break;
            case FacetWidgetType.SINGLE_TOGGLE:
              Component = SingleToggle;
              break;
            case FacetWidgetType.SINGLE_SELECT:
              Component = SingleSelect;
              break;
            case FacetWidgetType.MULTI_SELECT:
            default:
              Component = MultiFilter;
          }
          if (facetDefinition.facetName.value === 'monthyear') {
            Component = DateFilter;
          }
          return /*#__PURE__*/React.createElement(Component, {
            key: facetDefinition.facetName.value,
            label: facetDefinition.facetLabel.value,
            filterName: facetDefinition.facetName.value,
            setFilterDropdownState: _this2.setFilterDropdownState,
            items: _this2.props.facets[facetDefinition.facetName.value] || {},
            isOpen: Boolean(_this2.state.facetsWidgetsOpenStatus[facetDefinition.facetName.value]),
            resultsAmount: _this2.props.resultsAmount,
            setFilterChoiceState: _this2.setFilterChoiceState,
            setFilterMultipleChoicesState: _this2.setFilterMultipleChoicesState,
            filters: _this2.props.filters[facetDefinition.facetName.value] || [],
            resetFilterChoiceState: _this2.resetFilterChoiceState,
            clearAllLabel: _this2.props.clearAllButtonLabel,
            showNResultsLabel: _this2.props.showNResultsLabel,
            filtersClickAnalytics: filtersClickAnalytics,
            fitlersCategoryAnalytics: fitlersCategoryAnalytics,
            fitlersClearAnalytics: fitlersClearAnalytics,
            fitlersValueAnalytics: fitlersValueAnalytics,
            filtersShowResultsAnalytics: filtersShowResultsAnalytics,
            params: params
          });
        }))), index === 0 && /*#__PURE__*/React.createElement("div", {
          className: "col-md-auto col-lg-2 d-flex justify-content-end align-items-end filter__col-clear"
        }, /*#__PURE__*/React.createElement("a", {
          className: "body-medium link-clear filter-panel__row-clear",
          href: "/#",
          "aria-label": "Clear fitlers",
          onClick: function onClick(e) {
            tealiumClickFunc(tealiumMergeClickData(fitlersClearAnalytics, params));
            _this2.resetFilters(e);
          }
        }, _this2.props.clearAllButtonLabel))));
      })), /*#__PURE__*/React.createElement("div", {
        className: "filter__btn-row"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary js-filters-close",
        onClick: this.submitAll
      }, this.props.showNResultsLabel.replace('{#resultsAmount#}', ''))))));
    }
  }]);
}(React.Component);
_defineProperty(FilterBlock, "defaultProps", {
  filtersButtonLabel: 'Filters',
  clearButtonLabel: 'Clear',
  clearAllButtonLabel: 'Clear All',
  cancelButtonLabel: 'Cancel',
  showNResultsLabel: 'Show {#resultsAmount#} results CUSTOM'
});
// Check/uncheck particular value inside multiselect filter.
_defineProperty(FilterBlock, "toggleItem", function () {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 ? arguments[1] : undefined;
  var add = arguments.length > 2 ? arguments[2] : undefined;
  var items = _toConsumableArray(array);
  var index = items.findIndex(function (item) {
    return item === value;
  });
  index > -1 && !add ? items.splice(index, 1) : add && items.push(value);
  return items;
});
export default FilterBlock;